<template>
  <div
    :id="`invoice-accordion-${invoice_request.id}`"
    action="/api/invoice_request/update"
    method="post"
    class="live-form card invoice-request m-0 mb-2"
  >
    <div class="card-header">
      <div class="row">
        <div class="col-9 d-flex align-items-center pr-0 pl-2">
          <h4 class="m-0">Invoice Request - {{ invoice_request.user.first_name }} {{ invoice_request.user.last_name }} {{ invoice_request.invoice_group && invoice_request.invoice_group.completed ? `${invoice_request.invoice_group.start_date}-${invoice_request.invoice_group.end_date}` : '' }}</h4>
        </div>
        <div class="col align-items-center justify-content-end pl-0 pr-2">
          <button
            v-tooltip="'Minimize/maximize this section.'"
            class="btn btn-link py-0"
            :class="{ collapsed: invoice_request.invoice_group && invoice_request.invoice_group.completed }"
            data-toggle="collapse"
            :data-target="`#invoice-accordion-${invoice_request.id}-body-active`"
            aria-expanded="true"
            :aria-controls="`invoice-accordion-${invoice_request.id}-body-active`"
          ></button>
          <button
            v-if="!room || (room && !room.completed_date)"
            v-tooltip="'Delete invoice request'"
            class="btn btn-outline-white form-btn px-2 mx-1 py-1"
            type="button"
            @click="clone_remove('/api/invoice_request/delete', invoice_request, invoice_requests, invoice_request_index)"
          >
            <i class="fas fa-trash"></i>
          </button>
          <button
            v-if="!room || (room && !room.completed_date)"
            v-tooltip="'Add invoice request'"
            class="btn btn-outline-white form-btn px-2 py-1"
            type="button"
            @click="
              clone_create(
                '/api/invoice_request/create',
                {
                  placement_id: hotel_placement.placement_id,
                  hotel_placement_id: hotel_placement.id,
                  hotel_placement_room_id: room ? room.id : null,
                  created_from: 'hotel_placement'
                },
                invoice_requests,
                model
              )
            "
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>
    </div>

    <div
      :id="`invoice-accordion-${invoice_request.id}-body-active`"
      class="collapse"
      :class="{ show: !(invoice_request.invoice_group && invoice_request.invoice_group.completed) }"
      :aria-labelledby="`invoice-accordion-${invoice_request.id}-header-active`"
      :data-parent="`#invoice-accordion-${invoice_request.id}`"
    >
      <div class="card-body">
        <div class="form-row">
          <div class="col">
            <h5 class="py-2 border-bottom mb-2">
              <strong>Invoice Info</strong>
            </h5>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label :class="{ 'form-input-readonly bg-white': false }">Start Date</label>
              <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                <v-datepicker
                  v-model="invoice_request.start_date"
                  v-tooltip="invoice_request.start_date"
                  type="text"
                  name="start_date"
                  autocomplete="off"
                  class="form-control datepicker"
                  value=""
                  :disable="false"
                  pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"
                ></v-datepicker>
                <span class="form-control-date-custom "></span>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label :class="{ 'form-input-readonly bg-white': false }">End Date</label>
              <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                <v-datepicker
                  v-model="invoice_request.end_date"
                  v-tooltip="invoice_request.end_date"
                  type="text"
                  name="end_date"
                  autocomplete="off"
                  class="form-control datepicker"
                  value=""
                  :disable="false"
                  pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"
                ></v-datepicker>
                <span class="form-control-date-custom "></span>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
        </div>
        <div v-if="room" class="form-row">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Room #</label>
              <div class="form-control-wrap">
                <span class="badge-gray form-control alphanumeric-field">{{ room.room_no }}</span>
                <v-hidden v-model="room.room_no" class="form-control" name="room_no"></v-hidden>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <div class="form-check " tabindex="0" :class="{ 'form-input-readonly': false }">
                <v-checkbox v-model="invoice_request.folios_completed" class="form-check-input" name="folios_completed"></v-checkbox>
                <label class="form-check-label">
                  <div class="form-check-label-inner">Folios Completed</div>
                  <span class="form-check-custom"></span>
                </label>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div
                class="form-check"
                tabindex="0"
                :class="{ 'form-input-readonly': false, 'bg-light': invoice_request.invoice_group && invoice_request.invoice_group.completed }"
              >
                <v-checkbox
                  v-model="invoice_request.invoiceable"
                  class="form-check-input"
                  name="invoiceable"
                  :disabled="invoice_request.invoice_group && invoice_request.invoice_group.completed ? 'disabled' : false"
                ></v-checkbox>
                <label class="form-check-label">
                  <div class="form-check-label-inner">Send to Invoice Report</div>
                  <span class="form-check-custom"></span>
                </label>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
        </div>
        <div class="form-row align-items-end">
          <div class="col">
            <div class="form-group">
              <span v-if="invoice_request.notes" v-html="invoice_request.notes" class="d-none is-textfield"></span>
              <label class="form-control-wrap">Notes</label>
              <div class="form-control-wrap" :class="{ 'form-input-readonly': false }">
                <v-textarea
                  v-model="invoice_request.notes"
                  class="form-control alphanumeric-field ruled-textarea no-resize"
                  name="notes"
                  rows="4"
                  max-height="100000"
                  :readonly="false"
                  :important="true"
                  :autosize="true"
                ></v-textarea>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
        </div>
        <v-hidden v-model="invoice_request.id" class="form-control archive-skip" name="id"></v-hidden>
      </div>
    </div>

    <div class="card-footer bg-secondary"></div>
  </div>
</template>
<script>
export default {
  props: ["hotel_placement", "invoice_requests", "invoice_request", "invoice_request_index", "room", "model"],
  data() {
    return {
      id: this.invoice_request.id
    };
  },
  methods: {
    clone_create(url, post_data, arr, model) {
      this.$parent.clone_create(url, post_data, arr, model);
    },
    clone_remove(url, item, arr, index) {
      this.$parent.clone_remove(url, item, arr, index);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/hotel-invoice-requests.vue